<div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>

<div class="mt-34 ml-24 mr-24">
  <div *ngIf="!isLoading; else loader" [ngClass]="{'disabled': showLoader}">
    <div class="flex justify-between mb-8">
      <div class="mat-subtitle-1 fw-600 mb-0">
        {{'GROUPS.GROUPS' | transloco }}
      </div>
      @if (permissionsMap[PermissionKeys.GROUP_CREATE]) {
      <button type="button" class="flex justify-center items-center group-gradient mb-0 mat-subtitle-2 fs-16 fw-600" mat-button (click)="addGroup()">
        <mat-icon svgIcon="add" class="icon-md-2 pr-4"></mat-icon>
        {{'GROUPS.ADD_GROUP' | transloco }}
      </button>
      }
    </div>
    <div class="roles-table mt-28" *ngIf="data?.length > 0; else noDataFound">
      <div>
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mat-elevation">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="roles-name mat-subtitle-2 fw-700 fs-14 header pl-30 pt-12 pb-12">{{ 'GROUPS.GROUP_NAME' | transloco | uppercase }}</th>
            <td mat-cell *matCellDef="let data" class="roles-name items-center">
              <span class="name overflow-text pr-26 fw-500 cursor-pointer" [title]="data?.name" (click)="permissionsMap[PermissionKeys.ROLE_ASSIGN_READ] ? groupNameClick(data) : '' ">{{data?.name}}</span>
            </td>
          </ng-container>
      
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="roles-desc mat-subtitle-2 fw-700 fs-14 header pt-12 pb-12">{{ 'GROUPS.DESCRIPTION' | transloco | uppercase }}</th>
            <td mat-cell *matCellDef="let data" class="roles-desc" [title]="data?.description ? data?.description : '-'">
              <span class="overflow-text pr-26 fw-500">{{data?.description ? data?.description : '-'}}</span>
            </td>
          </ng-container>
      
          <ng-container matColumnDef="assigned">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="roles-assigned mat-subtitle-2 fw-700 fs-14 header pt-12 pb-12">{{ 'GROUPS.ROLE_ASSIGNED' | transloco | uppercase }}</th>
            <td mat-cell *matCellDef="let data" class="roles-assigned fw-500">{{data?.assigned ? data?.assigned : '-'}}</td>
          </ng-container>
      
          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef class="roles-delete mat-subtitle-2 fw-700 fs-14 header pt-12 pb-12"></th>
            <td mat-cell *matCellDef="let data" class="roles-delete" (click)="data?.name !== 'portal-management-user-admin' ? deleteGroup(data) : ''">
              <span *ngIf="data?.name !== 'portal-management-user-admin'" class="delete-text fw-500 delete-text cursor-pointer mr-26">{{ 'BUTTONS.DELETE' | transloco }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="assignRole">
            <th mat-header-cell *matHeaderCellDef class="roles-assign mat-subtitle-2 fw-700 fs-14 header pt-12 pb-12"></th>
            <td mat-cell *matCellDef="let data" class="roles-assign fw-700 mat-subtitle-2 fs-16 cursor-pointer" [ngClass]="{'disable-group': data?.name === 'portal-management-user-admin'}"
              matTooltipClass="above" matTooltipPosition="above" [matTooltip]="data?.name === 'portal-management-user-admin' ? ('GROUPS.DISABLE_GROUP'| transloco) : ''" (click)="data?.name !== 'portal-management-user-admin' ? assignRole(data) : ''">
              <span class="assign-text pl-16 pr-16 pt-8 pb-8 mr-26">{{ 'GROUPS.ASSIGN_ROLE' | transloco }}</span>
            </td>
          </ng-container>
      
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
    <div class="pl-24 pr-24">
      <app-paginator class="p-24" [length]="data?.length" [pageSizeOptions]="[10, 15, 20]"
      [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)"></app-paginator>
    </div>
    <ng-template #noDataFound>
      <div class="no-data mt-16 flex items-center justify-center">{{ 'GROUPS.NO_DATA_FOUND' | transloco }}</div>
    </ng-template>
  </div>
  <ng-template #loader>
    <div *ngIf="isLoading" class="flex spinner-container spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </div>
  </ng-template>
  <div *ngIf="showLoader">
    <mat-card class="flex spinner-container load-spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </mat-card>
  </div>
</div>